export default function defer() {
    if (!!Promise.defer) {
        return Promise.defer();
    } else {
        let deferred = {};
        let promise = new Promise(function (resolve, reject) {
            deferred.resolve = resolve;
            deferred.reject = reject;
        });
        deferred.promise = promise;
        return deferred;
    }
}